import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-estimate",
  "use": "icon-estimate-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-estimate\">\n<path d=\"M6.4-0.3c-5.5,0-10,4.5-10,10c0,5.5,4.5,10,10,10s10-4.5,10-10C16.4,4.1,12-0.3,6.4-0.3z M10.3,8.8v0.6H8l-0.8,1.3h3v0.6h-3\n\tv3H5.6v-3H2.6v-0.6h3L4.9,9.5H2.6V8.8h1.9l-2.2-4h1.9l2.2,4.5l2.2-4.5h1.9l-2.2,4H10.3z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol